import { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  InputGroup
} from "react-bootstrap";

import { NumericFormat } from "react-number-format";

const ModalEdicaoProduto = ({
  produto,
  onSave,
  onClose,
}) => {
  // ==========================================
  // ESTADO
  // ==========================================
  const [produtoEditado, setProdutoEditado] =
    useState({
      ...produto,

      QTD: produto.QTD || 0,
      QTD_EMBALAGEM:
        produto.QTD_EMBALAGEM || 1,

      COMPRA: produto.COMPRA || 0,

      ALI_ICMS: produto.ALI_ICMS || 0,
      ALI_IPI: produto.ALI_IPI || 0,
      ALI_PIS: produto.ALI_PIS || 0,
      ALI_COFINS:
        produto.ALI_COFINS || 0,
    });

  // ==========================================
  // HANDLE CHANGE
  // ==========================================
  const handleChange = (campo, valor) => {
    setProdutoEditado((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  // ==========================================
  // CÁLCULOS
  // ==========================================
  const quantidade =
    Number(produtoEditado.QTD) || 0;

  const qtdEmbalagem =
    Number(
      produtoEditado.QTD_EMBALAGEM
    ) || 1;

  const valorUnitario =
    Number(produtoEditado.COMPRA) || 0;

  const qtdUnitizada =
    quantidade * qtdEmbalagem;

  const total = Number(
    (quantidade * valorUnitario).toFixed(2)
  );

  // ==========================================
  // ALÍQUOTAS
  // ==========================================
  const aliIcms =
    Number(produtoEditado.ALI_ICMS) || 0;

  const aliIpi =
    Number(produtoEditado.ALI_IPI) || 0;

  const aliPis =
    Number(produtoEditado.ALI_PIS) || 0;

  const aliCofins =
    Number(produtoEditado.ALI_COFINS) || 0;

  // ==========================================
  // BASES
  // ==========================================
  const bcIcms = aliIcms > 0 ? total : 0;

  const bcIpi = total;

  const bcPis = total;

  const bcCofins = total;

  // ==========================================
  // VALORES
  // ==========================================
  const valorIcms = Number(
    ((bcIcms * aliIcms) / 100).toFixed(2)
  );

  const valorIpi = Number(
    ((bcIpi * aliIpi) / 100).toFixed(2)
  );

  const valorPis = Number(
    ((bcPis * aliPis) / 100).toFixed(2)
  );

  const valorCofins = Number(
    ((bcCofins * aliCofins) / 100).toFixed(2)
  );

  // ==========================================
  // SINCRONIZA ESTADO
  // ==========================================
  useEffect(() => {
    setProdutoEditado((prev) => ({
      ...prev,

      QTD_UNITIZADA:
        qtdUnitizada,

      TOTAL: total,

      BC_ICMS: bcIcms,
      VALOR_ICMS: valorIcms,

      BC_IPI: bcIpi,
      VALOR_IPI: valorIpi,

      BC_PIS: bcPis,
      VALOR_PIS: valorPis,

      BC_COFINS: bcCofins,
      VALOR_COFINS: valorCofins,
    }));
  }, [
    qtdUnitizada,
    total,

    bcIcms,
    valorIcms,

    bcIpi,
    valorIpi,

    bcPis,
    valorPis,

    bcCofins,
    valorCofins,
  ]);

  return (
    <Modal
      show
      onHide={onClose}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Editar Produto
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* ========================================== */}
          {/* PRODUTO */}
          {/* ========================================== */}

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Código
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    produtoEditado.COD_PRODUTO ||
                    ""
                  }
                  readOnly
                />
              </Form.Group>
            </Col>

            <Col md={9}>
              <Form.Group>
                <Form.Label>
                  Descrição
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    produtoEditado.DESCRICAO ||
                    ""
                  }
                  onChange={(e) =>
                    handleChange(
                      "DESCRICAO",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={2}>
              <Form.Group>
                <Form.Label>
                  Unidade
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    produtoEditado.UNIDADE ||
                    ""
                  }
                  onChange={(e) =>
                    handleChange(
                      "UNIDADE",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group>
                <Form.Label>
                  CFOP
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    produtoEditado.CFOP ||
                    ""
                  }
                  onChange={(e) =>
                    handleChange(
                      "CFOP",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>

            {/* ========================================== */}
            {/* VALOR UNITÁRIO */}
            {/* ========================================== */}

            <Col md={2}>
              <Form.Group>
                <Form.Label>
                  Valor Unitário
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={
                    produtoEditado.COMPRA
                  }
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  allowNegative={false}
                  onValueChange={(
                    values
                  ) => {
                    handleChange(
                      "COMPRA",
                      values.floatValue ||
                        0
                    );
                  }}
                />
              </Form.Group>
            </Col>

            {/* ========================================== */}
            {/* QTD EMBALAGEM */}
            {/* ========================================== */}

            <Col md={2}>
              <Form.Group>
                <Form.Label>
                  Qtd Emb.
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={
                    produtoEditado.QTD_EMBALAGEM
                  }
                  decimalSeparator=","
                  decimalScale={0}
                  allowNegative={false}
                  onValueChange={(
                    values
                  ) => {
                    handleChange(
                      "QTD_EMBALAGEM",
                      values.floatValue ||
                        0
                    );
                  }}
                />
              </Form.Group>
            </Col>

            {/* ========================================== */}
            {/* QTD */}
            {/* ========================================== */}

            <Col md={2}>
              <Form.Group>
                <Form.Label>
                  Qtd Pedida
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={
                    produtoEditado.QTD
                  }
                  decimalSeparator=","
                  decimalScale={3}
                  allowNegative={false}
                  onValueChange={(
                    values
                  ) => {
                    handleChange(
                      "QTD",
                      values.floatValue ||
                        0
                    );
                  }}
                />
              </Form.Group>
            </Col>

            {/* ========================================== */}
            {/* QTD UNITIZADA */}
            {/* ========================================== */}

            <Col md={2}>
              <Form.Group>
                <Form.Label>
                  Qtd Unitizada
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={qtdUnitizada}
                  decimalSeparator=","
                  decimalScale={3}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ========================================== */}
          {/* TOTAL */}
          {/* ========================================== */}

          <Row className="mb-4">
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Total
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={total}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ========================================== */}
          {/* ICMS */}
          {/* ========================================== */}

          <h5>ICMS</h5>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  CST
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    produtoEditado.ST_ICMS ||
                    ""
                  }
                  onChange={(e) =>
                    handleChange(
                      "ST_ICMS",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>

            {/* BASE ICMS */}

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Base ICMS
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={bcIcms}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  disabled
                />
              </Form.Group>
            </Col>

            {/* ALIQUOTA */}

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Alíquota
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={
                    produtoEditado.ALI_ICMS
                  }
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  suffix="%"
                  allowNegative={false}
                  onValueChange={(
                    values
                  ) => {
                    handleChange(
                      "ALI_ICMS",
                      values.floatValue ||
                        0
                    );
                  }}
                />
              </Form.Group>
            </Col>

            {/* VALOR */}

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Valor ICMS
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={valorIcms}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ========================================== */}
          {/* IPI */}
          {/* ========================================== */}

          <h5>IPI</h5>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  CST
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    produtoEditado.ST_IPI ||
                    ""
                  }
                  onChange={(e) =>
                    handleChange(
                      "ST_IPI",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Base IPI
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={bcIpi}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Alíquota
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={
                    produtoEditado.ALI_IPI
                  }
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  suffix="%"
                  allowNegative={false}
                  onValueChange={(
                    values
                  ) => {
                    handleChange(
                      "ALI_IPI",
                      values.floatValue ||
                        0
                    );
                  }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Valor IPI
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={valorIpi}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ========================================== */}
          {/* PIS */}
          {/* ========================================== */}

          <h5>PIS</h5>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  CST
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    produtoEditado.ST_PIS ||
                    ""
                  }
                  onChange={(e) =>
                    handleChange(
                      "ST_PIS",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Base PIS
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={bcPis}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Alíquota
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={
                    produtoEditado.ALI_PIS
                  }
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  suffix="%"
                  allowNegative={false}
                  onValueChange={(
                    values
                  ) => {
                    handleChange(
                      "ALI_PIS",
                      values.floatValue ||
                        0
                    );
                  }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Valor PIS
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={valorPis}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ========================================== */}
          {/* COFINS */}
          {/* ========================================== */}

          <h5>COFINS</h5>

          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  CST
                </Form.Label>

                <Form.Control
                  type="text"
                  value={
                    produtoEditado.ST_COFINS ||
                    ""
                  }
                  onChange={(e) =>
                    handleChange(
                      "ST_COFINS",
                      e.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Base COFINS
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={bcCofins}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Alíquota
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={
                    produtoEditado.ALI_COFINS
                  }
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  suffix="%"
                  allowNegative={false}
                  onValueChange={(
                    values
                  ) => {
                    handleChange(
                      "ALI_COFINS",
                      values.floatValue ||
                        0
                    );
                  }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <Form.Label>
                  Valor COFINS
                </Form.Label>

                <NumericFormat
                  customInput={
                    Form.Control
                  }
                  value={valorCofins}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$ "
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onClose}
        >
          Cancelar
        </Button>

        <Button
          variant="primary"
          onClick={() =>
            onSave(produtoEditado)
          }
        >
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEdicaoProduto;
